import { render, staticRenderFns } from "./detection-corpus-collapse.vue?vue&type=template&id=ce950250&"
import script from "./detection-corpus-collapse.vue?vue&type=script&lang=js&"
export * from "./detection-corpus-collapse.vue?vue&type=script&lang=js&"
import style0 from "./detection-corpus-collapse.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports